<template>
    <div>
        <CList :pConfigList="ConfigList" :segurity="segurity">
            <template slot="bodyForm">
                <CLoader :pConfigLoad="ConfigLoad">
                    <template slot="BodyFormLoad">
                        <form id="FormEncuestaResuelta" class="form-horizontal" method="post" autocomplete="off" onSubmit="return false">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="form-group row" v-for="(item,index) in Preguntas.encuesta_pregunta_resuelta" :key="index">
                                            <label for="">{{(index+1)+'.- '+item.Pregunta }}</label>
                                            <div v-if="item.TipoPregunta=='1' || item.TipoPregunta=='2'">
                                                <div class="row" v-if="item.TipoPregunta=='1'">
                                                    <div v-for="(itemDefault,indexDefault) in OpcionesDefault" :key="indexDefault" class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                        <div v-if="item.TipoRespuesta=='UNICO'" class="form-check">
                                                            <input 
                                                                :disabled="itemDefault.IdConfigEncuestaOpcionPrederteminada!=item.Respuestas[0].IdConfigEncuestaOpcionPredeterminada" 
                                                                type="radio" 
                                                                class="form-check-input" 
                                                                :id="'flexRadioDefault_'+index+'_'+indexDefault" 
                                                                :checked="itemDefault.IdConfigEncuestaOpcionPrederteminada==item.Respuestas[0].IdConfigEncuestaOpcionPredeterminada">
                                                            <label class="form-check-label" :for="'flexRadioDefault_'+index+'_'+indexDefault">
                                                                {{ itemDefault.Nombre }}
                                                            </label>
                                                        </div>
                                                        <div v-if="item.TipoRespuesta=='MULTIPLE'" class="form-check">
                                                            <input type="checkbox" 
                                                                class="form-check-input" 
                                                                :id="'Check_'+index+'_'+indexDefault"
                                                                :checked="MarcarOpcionMultiple(item.Respuestas,itemDefault)"
                                                                :disabled="!MarcarOpcionMultiple(item.Respuestas,itemDefault)">
                                                            <label :for="'Check_'+index+'_'+indexDefault">{{ itemDefault.Nombre }}</label>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row" v-if="item.TipoPregunta=='2'">
                                                    <div v-for="(itemEncuesta,indexEncuesta) in OpcionesEncuesta" :key="indexEncuesta" class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                        <div v-if="item.TipoRespuesta=='UNICO'" class="form-check">
                                                            <input 
                                                                :disabled="itemEncuesta.IdConfigEncuestaOpcionPrederteminada!=item.Respuestas[0].IdConfigEncuestaOpcionPredeterminada" 
                                                                type="radio" 
                                                                class="form-check-input" 
                                                                :id="'flexRadioDefault_'+index+'_'+indexEncuesta" 
                                                                :checked="itemEncuesta.IdConfigEncuestaOpcionPrederteminada==item.Respuestas[0].IdConfigEncuestaOpcionPredeterminada">
                                                            <label class="form-check-label" :for="'flexRadioDefault_'+index+'_'+indexEncuesta">
                                                                {{ itemEncuesta.Nombre }}
                                                            </label>
                                                        </div>
                                                        <div v-if="item.TipoRespuesta=='MULTIPLE'" class="form-check">
                                                            <input 
                                                                type="checkbox" 
                                                                class="form-check-input" 
                                                                :id="'Check_'+index+'_'+indexEncuesta"
                                                                :checked="MarcarOpcionMultiple(item.Respuestas,itemEncuesta)"
                                                                :disabled="!MarcarOpcionMultiple(item.Respuestas,itemEncuesta)"
                                                                >
                                                            <label :for="'Check_'+index+'_'+indexEncuesta">{{ itemEncuesta.Nombre }}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row" v-if="item.TipoPregunta=='3'">
                                                <div v-for="(itemRespuesta,indexRespuesta) in item.Anexadas" :key="indexRespuesta" class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                    <div v-if="item.TipoRespuesta=='UNICO'" class="form-check">
                                                        <div class="form-check">
                                                            <input 
                                                                type="radio" 
                                                                class="form-check-input" 
                                                                :checked="item.Respuestas[0].IdConfigEncuestaRespuesta==itemRespuesta.IdConfigEncuestaRespuesta"
                                                                :disabled="item.Respuestas[0].IdConfigEncuestaRespuesta!=itemRespuesta.IdConfigEncuestaRespuesta" 
                                                                :id="'flexRadioDefault_'+index+'_'+indexRespuesta" 
                                                                >
                                                            <label class="form-check-label" :for="'flexRadioDefault_'+index+'_'+indexRespuesta">
                                                                {{ itemRespuesta.Respuesta }}
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div v-if="item.TipoRespuesta=='MULTIPLE'" class="form-check">
                                                        <input 
                                                            type="checkbox" 
                                                            class="form-check-input" 
                                                            :id="'Check_'+index+'_'+indexRespuesta"
                                                            :checked="MarcarOpcionesAnexadas(item.Respuestas,itemRespuesta)"
                                                            :disabled="!MarcarOpcionesAnexadas(item.Respuestas,itemRespuesta)"
                                                            >
                                                        <label :for="'Check_'+index+'_'+indexRespuesta">{{ itemRespuesta.Respuesta }}</label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div v-if="item.TipoPregunta=='4'" class="col-lg-12">
                                                <div class="form-check-inline" v-for="(itemPregunta,indexPregunta) in Valoracion" :key="indexPregunta">
                                                    <input 
                                                        type="radio" 
                                                        class="form-check-input d-none valorseleccionado" 
                                                        :id="'Pregunta_'+index+'_'+indexPregunta"
                                                        :checked="itemPregunta==item.Respuestas[0].Puntuacion"
                                                        :disabled="itemPregunta!=item.Respuestas[0].Puntuacion">
                                                    <label class="form-check-label" :for="'Pregunta_'+index+'_'+indexPregunta">{{ itemPregunta }}</label>
                                                </div>
                                            </div>

                                            <div v-if="item.TipoPregunta=='5'" class="col-lg-12">
                                                <div class="row">
                                                    <div class="col-lg-1">
                                                        <div class="form-check">
                                                            <input :disabled="item.Respuestas[0].SiNo=='NO'" type="radio" class="form-check-input" v-model="item.Respuestas[0].SiNo" :id="'Si_'+index" value="SI">
                                                            <label :for="'Si_'+index" class="form-check-label">SI</label>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-1">
                                                        <div class="form-check">
                                                            <input :disabled="item.Respuestas[0].SiNo=='SI'" type="radio" class="form-check-input" v-model="item.Respuestas[0].SiNo" :id="'No_'+index" value="NO">
                                                            <label :for="'No_'+index" class="form-check-label">NO</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div v-if="item.TipoPregunta=='6'" class="col-lg-12">
                                                <textarea disabled v-model="item.Respuestas[0].RespuestaText" cols="30" rows="3" class="form-control"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </template>
                </CLoader>
            </template>
        </CList>
    </div>
</template>

<script>
const EmitEjecuta="seccionEncuestaResuelta";
export default {
    props:['objEnviado'],
    data() {
        return {
            ConfigList:{
                Title:'Encuestas',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: false,
                ShowPaginador: false,
                TypeBody: 'Form',
				TitleFirst: 'Encuesta Respondida',
				EmitSeccion: EmitEjecuta,
            },
            ConfigLoad:{
                ShowLoader: false,
                ClassLoad: false,
            },
            segurity: {},
            errorvalidacion: [],
			Emit: EmitEjecuta,
            Preguntas:[],
            OpcionesDefault:[],
            OpcionesEncuesta:[],
            Respuestas:[],
            Valoracion:[1,2,3,4,5,6,7,8,9,10]
        }
    },
    methods: {
        async Lista(){
            this.$http.get('/encuestaResuelta',{
                params:{
                    IdBodaCopia:this.objEnviado.IdBodaCopia,
                    IdCliente:this.objEnviado.IdCliente,
                    IdUserHotel:this.objEnviado.IdContacto,
                    IdVendedor:this.objEnviado.IdVendedor,
                    TipoEncuesta:this.objEnviado.TipoEncuesta,
                }
            }).then((res)=>{
                this.Preguntas=res.data.data[0];
                this.SetearOpciones();
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            })
        },
        Regresar(){
            this.$router.push({name:'enviarEncuesta'});
        },
        SetearOpciones(){
            this.Preguntas.config_encuesta_opciones_predeterminadas.forEach((element)=>{
                if (element.Tipo=='opcion') {
                    this.OpcionesDefault.push(element);
                }
                else{
                    this.OpcionesEncuesta.push(element);
                }
            })
        },
        MarcarOpcionMultiple(Respuestas,Opcion){
            let BndMarcar=false;
            Respuestas.forEach((Respuesta)=>{
                if (Respuesta.IdConfigEncuestaOpcionPredeterminada==Opcion.IdConfigEncuestaOpcionPrederteminada) {
                    BndMarcar=true;
                }
            })
            return BndMarcar ? true : false;
        },
        MarcarOpcionesAnexadas(Respuestas,Anexada){
            let BndMarcar=false;
            Respuestas.forEach((Respuesta)=>{
                if (Respuesta.IdConfigEncuestaRespuesta==Anexada.IdConfigEncuestaRespuesta) {
                    BndMarcar=true;
                }
            })
            return BndMarcar ? true : false;
        }
    },
    created() {
        this.bus.$off('EmitReturn');
    },
    mounted() {
        this.Lista();
        this.bus.$on('EmitReturn',()=>{
            this.Regresar();
        })
    },
}
</script>

<style>

</style>